import PropTypes from 'prop-types';

export const sharedLeadFormProps = {
  lead: PropTypes.shape({
    contactId: PropTypes.number,
    contactType: PropTypes.string,
    contactPath: PropTypes.string,
    id: PropTypes.number.isRequired,
    listingId: PropTypes.number,
    referralSource: PropTypes.number,
    referralSourceFixed: PropTypes.bool,
    status: PropTypes.number
  }),
  leadStatuses: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number.isRequired,
    label: PropTypes.string.isRequired
  })).isRequired,
  leaseChecked: PropTypes.bool,
  saleChecked: PropTypes.bool,
  useVaultGates: PropTypes.bool,
};
